import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import useAuth from 'hooks/useAuth';
import { hasOrganizationPermission } from 'utils/organizationPermissions';

OrganizationPermissionGuard.propTypes = {
  children: PropTypes.node,
  permissions: PropTypes.arrayOf(PropTypes.string),
};

export default function OrganizationPermissionGuard({ children, permissions }) {
  const { user } = useAuth();

  if (!hasOrganizationPermission(user?.organizationRole, permissions)) {
    return <Navigate to='/403' replace />;
  }

  return children;
}
